import { Box, Grid, TextField, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../../constants/FieldsConst';
import { validMessage } from '../../../../../constants/ValidsFormConst';
import { useNotification } from '../../../../../helpers/Notification';
import { LoadingWidget } from '../../../../../widgets';
import SelectFieldEvaluacionesComponent from '../../../../academico/evaluaciones/components/SelectFieldEvaluaciones';
import BotonComponent from '../../../../dashboard/components/BotonNuevo';
import { savePtemEvaluacionesAction } from '../PtemEvaluacionesAction';

const FormPtemEvaluaciones = ({ totalPuntosRestantes, setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const planEvaluacionStore = Redux.useSelector(
    (state) => state.planEvaluacion,
  );
  const planevaTemasStore = Redux.useSelector((state) => state.planevaTemas);
  const ptemEvaluacionesStore = Redux.useSelector(
    (state) => state.ptemEvaluaciones,
  );

  const planevaTema = planevaTemasStore.activo;
  const activo = ptemEvaluacionesStore.activo;

  const initData = {
    ponderacion: '',
    desc: '',
    idEvaluacion: '',
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    idEvaluacion: false,
    ponderacion: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  React.useEffect(() => {
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    setTimeout(
      () =>
        setData({
          ...values,
          idEvaluacion: activo.evaluacion.id,
        }),
      300,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSubmit = async () => {
    if (await _validDataForm()) {
      setLoadingSave(true);
      let res = await savePtemEvaluacionesAction(
        { dispatch, notify },
        planEvaluacionStore.activo.id,
        activo?.id,
        {
          ...data,
          ponderacion: parseFloat(data.ponderacion).toFixed(2),
          idPlanevaTema: planevaTema.id,
        },
        planEvaluacionStore.params,
      );
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  return (
    planevaTema && (
      <Box component="form">
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
            <Typography variant="body1" color="initial">
              <strong>Tema: </strong>
              {planevaTema.tema.titulo}
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <SelectFieldEvaluacionesComponent
              id="selectEvaluaciones"
              value={data.idEvaluacion}
              isEmpty={false}
              onChange={(idEvaluacion) => {
                _handleSetDataField(CONST.evaluacion.idName, idEvaluacion);
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              size="small"
              id={CONST.ponderacion.name}
              required
              label={CONST.ponderacion.label}
              value={data.ponderacion}
              autoComplete="off"
              disabled={ptemEvaluacionesStore.activo}
              onChange={(e) => {
                if (Number(e.target.value) > totalPuntosRestantes) {
                  _handleSetDataField(
                    CONST.ponderacion.name,
                    totalPuntosRestantes,
                  );
                  return;
                }
                _handleSetDataField(CONST.ponderacion.name, e.target.value);
              }}
              helperText={dataError.ponderacion ? validMessage.required : null}
              error={dataError.ponderacion}
              type="number"
              InputProps={{
                inputProps: { min: 1, max: totalPuntosRestantes },
              }}
            />
          </Grid>

          <Grid item xs={12} md={12}>
            <TextField
              fullWidth
              size="small"
              id={CONST.desc.name}
              label={CONST.desc.label}
              value={data.desc}
              multiline
              rows={2}
              onChange={(e) =>
                _handleSetDataField(CONST.desc.name, e.target.value)
              }
            />
          </Grid>
          <Grid item xs={12} md={12} align="center">
            <BotonComponent
              click={_handleSubmit}
              save
              disabled={loadingSave}
              green
            />
          </Grid>
        </Grid>
      </Box>
    )
  );
};

export default FormPtemEvaluaciones;
